// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2yuqj","insightsList":"newBusinessInsightsMenu_insightsList__2FVLH","active":"newBusinessInsightsMenu_active__1BUjo"};